'use client';

import { useState } from 'react';
import classes from './RichBlocks.module.scss';
import { IconCheck, IconDownload } from '@tabler/icons-react';
import { Button, Text } from '@mantine/core';
import type { RichBlock } from '@/src/types/RichBlock';

function buildMarkdown(block: RichBlock & { type: 'confluenceTemplate' }): string {
  const items = block.items
    .map((item) => `- [${item.checked ? 'x' : ' '}] ${item.text}`)
    .join('\n');

  return `# ${block.title}\n\n${block.description}\n\n## Checklist\n\n${items}\n`;
}

export function ConfluenceTemplateBlock({
  block,
}: {
  block: RichBlock & { type: 'confluenceTemplate' };
}) {
  const [downloaded, setDownloaded] = useState(false);

  const handleDownload = () => {
    const markdown = buildMarkdown(block);
    const blob = new Blob([markdown], { type: 'text/markdown;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${block.fileName || 'template'}.md`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    setDownloaded(true);
    setTimeout(() => setDownloaded(false), 3000);
  };

  return (
    <div className={`${classes.richBlock} ${classes.confluenceTemplateBlock}`}>
      {block.title && <div className={classes.richBlockTitle}>{block.title}</div>}
      {block.description && (
        <Text className={classes.richBlockDescription} size="sm" c="dimmed" mb="sm">
          {block.description}
        </Text>
      )}
      <ul className={classes.checklist}>
        {block.items.map((item, i) => (
          <li key={i} className={classes.checklistItem}>
            <span className={classes.checkBox}>{item.checked ? '☑' : '☐'}</span>
            <span>{item.text}</span>
          </li>
        ))}
      </ul>
      <Button
        onClick={handleDownload}
        leftSection={downloaded ? <IconCheck size={16} /> : <IconDownload size={16} />}
        variant="light"
        size="sm"
        mt="md"
      >
        {downloaded ? 'Téléchargé' : 'Télécharger le template Confluence'}
      </Button>
    </div>
  );
}
